import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-navigate-column-molecule',
  templateUrl: './navigate-column-molecule.component.html',
  styleUrls: ['./navigate-column-molecule.component.scss']
})
export class NavigateColumnMoleculeComponent {
  @Input() data: any;
  @Input() header: any;
}
